import { render, staticRenderFns } from "./ConfettiTriangle.vue?vue&type=template&id=9bfbcce6&lang=pug&"
import script from "./ConfettiTriangle.vue?vue&type=script&lang=js&"
export * from "./ConfettiTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports